<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold">“They lead with clarity and confidence.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reflects <span class="font-bold">true readiness at the edge.</span>
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People don’t wait for permission - they act on principles and mission
      clarity.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews are trained so the right person leads - not the
      highest-ranking. That’s real speed.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic">How do we multiply this capability?</span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Break down how they responded and use it to teach others. Ready moments
      should become system-wide learning.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold"
        >“They freeze or second-guess and need my help.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows hesitation under pressure - a sign your team hasn’t been
      equipped to lead in real time.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In elite environments, hesitation is a signal of unclear rules of
      engagement - not personal weakness.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Run simulations. Build reps. Ask: <span class="italic"
        >How would we handle X without me?</span
      >
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Give the team a framework for pressure response - then let them train to
      own it.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold"
        >“They avoid it, hoping someone else will act.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a <span class="font-bold"
        >gap in courage, clarity, or culture.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People don’t trust themselves - or the environment - enough to move.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a sub, waiting means wasting time - or letting the situation escalate
      beyond control.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Create a team norm: <span class="italic"
        >Whoever’s closest owns the first move.
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then coach them through taking that action and communicating it fast.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold"
        >“I have to step in because no one else will.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows a breakdown in distributed leadership. You’ve become the
      fallback - again.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews fail when the leader is the only point of initiative.
      Readiness means action from the edges in, not top-down.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Pick one pressure scenario from the past quarter. Debrief it with your
      team.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Ask: <span class="italic"
        >What would have made someone else act first?</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Then build that capability deliberately - with reps, clarity, and
      coaching.
    </p>
  {/if}
</div>
